import React from "react";
import { FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";

import { useMe } from "../../hooks/queries";
import { AccountType } from "../../models/AccountData";
import { getEnvironment } from "../../utils/getEnvironment";
import glitchyChan from "../glitchy_chan.png";

import "./styles.scss";

const RootErrorFallback = ({ error }: FallbackProps) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`errors.rootError.${key}`);

  const { data: me } = useMe();
  const isAdmin = me?.type === AccountType.ADMIN;
  const environment = getEnvironment();
  const showErrorBody = isAdmin || environment === "local";

  return (
    <div className="root-error-fallback-wrapper">
      <header className={`header`}>
        <div className="left-logo">
          <a href="/" className="icons btn-logo" aria-label="Home"></a>
        </div>
      </header>
      <div className="root-error-fallback">
        <div className="root-error-fallback-header">
          <h1>{t("title")}</h1>
        </div>
        <div className="root-error-fallback-image">
          <img src={glitchyChan} alt="" />
          <p>{t("apology")}</p>
          <p>{t("suggestion")}</p>
          <a href="/">{t("go_to_home")}</a>
        </div>
        {showErrorBody && (
          <div className="root-error-fallback-body">
            <p>{error.message}</p>
            <p>{error.stack}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RootErrorFallback;
